import { $api } from '@service/RequestService';
import { flatEndpoints } from '@utils/constants/apis';
import { useQuery } from 'react-query';

import { Field, fieldSchema } from 'modules/shaxmatka';

import { FIELD } from '../keys';

export interface IQuery {
  field: {
    list: Record<number, Field>;
    array: Field[];
  };
}

export const useFields = () => {
  const initialValue: IQuery = {
    field: {
      list: {},
      array: []
    }
  };

  const { data = initialValue, ...args } = useQuery<IQuery>(FIELD.list().queryKey, async () => {
    const { data } = await $api.get(flatEndpoints.FIELD);

    const list: Record<number, Field> = {};
    const array: Field[] = [];

    for (let field of (data?.data || []) as Field[]) {
      field = fieldSchema.parse(field);
      array.push({ ...field });
      list[field.id!] = field;
    }

    return { field: { list, array } };
  });

  return { ...data, ...args };
};
